const menu = {
    single_sign_on: 'Single sign-on',
    profile: 'Profilo',
    language: 'Lingua',
    appearance: {
        label: 'Aspetto',
        light: 'Modalità chiaro',
        dark: 'Modalità scuro',
        system: 'Sincronizza con sistema',
    },
    sign_out: 'Esci',
};
export default Object.freeze(menu);
